/* 🤖 this file was generated by svg-to-ts */
export const matIconCode: {
  name: 'code';
  data: string;
} = {
  name: 'code',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/></svg>`
};
